<div class="warn-dialog">
  <div class="title">
    <p>
      <img src="../../../../../../assets/svg/icons/success_ic.svg" alt="Sucesso" />
      Análise postural importada!
    </p>
    <mat-icon style="cursor: pointer; color: #5f6368" (click)="onConfirm()"
      >close</mat-icon
    >
  </div>

  <hr />

  <div class="content">
    <p>
      A importação da análise postural foi realizada com
      <strong>sucesso</strong>! Você pode acompanhar o status pela tela de
      <strong>histórico</strong>.
    </p>
  </div>

  <hr />

  <div class="modal-footer" mat-dialog-actions>
    <button matButton="filled" (click)="onConfirm()">Ok</button>
  </div>
</div>
